import {$$} from '@vue-macros/reactivity-transform/macros'
import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {
  IDatabaseItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseItemResponseInstance'
import {RestrictedEditReasonType} from '@toolify/client/src/modules/databases/enum/RestrictedEditReasonType'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {
  DatabasePropertyType,
} from '@toolify/server/src/models/mongoose/DatabasePropertyModel/enum/DatabasePropertyType'
import {
  IBooleanPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/BooleanPropertyTypeStrategy/types/IBooleanPropertyTypeInterfaces'

export function useBooleanPropertyTypeStrategy() {

  const getIsActive = (value: unknown, property: IDatabasePropertyResponseInstance, item: IDatabaseItemResponseInstance) => {
    return true
  }

  /**
   * Mirrors BooleanPropertyTypeStrategy.getGroups: with allowNull disabled the server folds unset
   * items into the false bucket, so this filter has to match them too, otherwise the header count
   * exceeds the list it fetches and the view keeps re-requesting the missing tail. Returning null
   * leaves the generic Equals filter in place - this composable also backs Rating, hence the type check.
   */
  const getGroupFilter = (
    group: string,
    groupItem: IDatabaseGroupItemResponseInstance,
    _showAllDatabaseGroups: boolean,
    property?: IDatabasePropertyResponseInstance,
  ): IFilter | null => {
    const options = property?.options as IBooleanPropertyTypeInterfaces['options'] | undefined
    if(property?.type !== DatabasePropertyType.Boolean || options?.allowNull || groupItem?.value !== false) {
      return null
    }
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.Or,
      items: [{
        type: FilterItemType.Property,
        id: group,
        subProperty: null,
        operator: {
          type: FilterPropertyOperator.Equals,
          options: {
            isCaseSensitive: true,
          },
        },
        payload: {
          type: FilterPropertyPayloadType.Static,
          value: false,
        },
        isDisabled: false,
      }, {
        type: FilterItemType.Property,
        id: group,
        subProperty: null,
        operator: {
          type: FilterPropertyOperator.Empty,
        },
        payload: {
          type: FilterPropertyPayloadType.Static,
          value: null,
        },
        isDisabled: false,
      }],
      isDisabled: false,
    } as IFilter
  }

  const hasRenderComponent = () => {
    return false
  }

  const getRestrictedEditReason = (): RestrictedEditReasonType | null => {
    return null
  }

  return $$({
    getIsActive,
    getGroupFilter,
    hasRenderComponent,
    getRestrictedEditReason,
  })
}
